<clp-toolbar [title]="('course.title' | translate)">
    <a
      [routerLink]="['/createCourse']"
      routerLinkActive="activeClass"
      class="clp-btn clp-btn-warning clp-btn-sm inline-flex items-center gap-2">
      <i class="fa-solid fa-plus"></i>
      <span>{{'general.create' | translate}}</span>
    </a>
</clp-toolbar>

<div class="px-4 py-3">
  @if (courses$ | async; as courses) {
    <div class="mb-3 grid grid-cols-2 gap-2 lg:grid-cols-4">
      <div class="rounded-lg border border-slate-700 bg-slate-900/55 p-2.5">
        <p class="text-xs uppercase tracking-wide text-slate-400">{{'course.title' | translate}}</p>
        <p class="mt-1 text-xl font-semibold text-slate-100">{{ courses.length }}</p>
      </div>
      <div class="rounded-lg border border-slate-700 bg-slate-900/55 p-2.5">
        <p class="text-xs uppercase tracking-wide text-slate-400">{{ 'course.enum.1' | translate }}</p>
        <p class="mt-1 text-xl font-semibold text-slate-200">{{ getCountByStatus(courses, 1) }}</p>
      </div>
      <div class="rounded-lg border border-slate-700 bg-slate-900/55 p-2.5">
        <p class="text-xs uppercase tracking-wide text-slate-400">{{ 'course.enum.2' | translate }}</p>
        <p class="mt-1 text-xl font-semibold text-emerald-300">{{ getCountByStatus(courses, 2) }}</p>
      </div>
      <div class="rounded-lg border border-slate-700 bg-slate-900/55 p-2.5">
        <p class="text-xs uppercase tracking-wide text-slate-400">{{ 'course.enum.4' | translate }}</p>
        <p class="mt-1 text-xl font-semibold text-amber-300">{{ getCountByStatus(courses, 4) }}</p>
      </div>
    </div>

    <div class="mb-3 rounded-lg border border-slate-700 bg-slate-900/55 p-2.5">
      <div class="grid gap-2 md:grid-cols-[minmax(0,1fr)_200px]">
        <div>
          <label class="mb-1 block text-xs uppercase tracking-wide text-slate-400">{{ 'course.name' | translate }}</label>
          <div class="relative">
            <i class="fa-solid fa-magnifying-glass pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-xs text-slate-500"></i>
            <input
              type="text"
              class="clp-input pl-9"
              [value]="searchTerm"
              (input)="onSearchChange($event)"
              [attr.placeholder]="'course.searchPlaceholder' | translate" />
          </div>
        </div>
        <div>
          <label class="mb-1 block text-xs uppercase tracking-wide text-slate-400">{{ 'course.status' | translate }}</label>
          <select class="clp-select" [value]="statusFilter" (change)="onStatusFilterChange($event)">
            <option value="all">{{ 'course.allStatuses' | translate }}</option>
            <option value="1">{{ 'course.enum.1' | translate }}</option>
            <option value="2">{{ 'course.enum.2' | translate }}</option>
            <option value="3">{{ 'course.enum.3' | translate }}</option>
            <option value="4">{{ 'course.enum.4' | translate }}</option>
          </select>
        </div>
      </div>
    </div>

    @let filteredCourses = getFilteredCourses(courses);

    @if (courses.length === 0) {
      <div class="clp-card">
        <div class="clp-card-body flex flex-col items-center gap-3 py-10 text-center">
          <i class="fa-solid fa-book-open text-3xl text-slate-500"></i>
          <p class="text-sm text-slate-300">{{ 'general.no' | translate }} {{ 'course.title' | translate }}</p>
          <a [routerLink]="['/createCourse']" class="clp-btn clp-btn-warning clp-btn-sm">{{'general.create' | translate}}</a>
        </div>
      </div>
    } @else if (filteredCourses.length === 0) {
      <div class="clp-card">
        <div class="clp-card-body flex flex-col items-center gap-2 py-8 text-center">
          <i class="fa-solid fa-filter-circle-xmark text-2xl text-slate-500"></i>
          <p class="text-sm text-slate-300">{{ 'course.noMatchingCourses' | translate }}</p>
        </div>
      </div>
    } @else {
      <div class="space-y-2">
        @for (course of filteredCourses; track course.id ?? $index) {
          <article class="group rounded-lg border border-slate-700 bg-slate-900/55 px-3 py-2.5 shadow-sm transition hover:border-amber-400/40 hover:bg-slate-900/75">
            <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
              <div class="min-w-0">
                <h3 class="truncate text-sm font-semibold text-slate-100">{{ course.title }}</h3>
                @if (course.headline) {
                  <p class="truncate text-xs text-slate-400">{{ course.headline }}</p>
                }
              </div>

              <div class="flex shrink-0 items-center gap-1.5">
                <span
                  class="rounded-full border px-2 py-0.5 text-[11px] font-semibold"
                  [ngClass]="getStatusBadgeClass(course.status)">
                  {{ 'course.enum.' + course.status | translate }}
                </span>

                <button
                  class="clp-btn clp-btn-warning clp-btn-sm"
                  (click)="editCourse(course.id)"
                  [attr.aria-label]="'general.edit' | translate"
                  [title]="'general.edit' | translate">
                  <i class="fa-regular fa-pen-to-square text-xs"></i>
                </button>

                <button
                  class="clp-btn clp-btn-danger clp-btn-sm"
                  (click)="deleteCourse(course.id)"
                  [attr.aria-label]="'general.delete' | translate"
                  [title]="'general.delete' | translate">
                  <i class="fa-solid fa-trash-can text-xs"></i>
                </button>
              </div>
            </div>
          </article>
        }
      </div>
    }
  }
</div>
